class Scroller {
  resizeEventAttached;
  scrollerEventsAttached;
  isDown;
  startX;
  scrollLeft;
  scrollerId;

  constructor(scrollerId) {
    this.resizeEventAttached = false;
    this.scrollerEventsAttached = false;
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.scrollerId = scrollerId;
  }

  attachWindowResize = () => {
    if (!this.resizeEventAttached) {
      this.resizeEventAttached = true;
      window.addEventListener("resize", this.onWindowResize);
    }

    if (window.innerWidth <= 1024) this.onWindowResize();
  };

  detachEvents = () => {
    if (this.resizeEventAttached) {
      this.resizeEventAttached = false;
      window.removeEventListener("resize", this.onWindowResize);
    }

    if (this.scrollerEventsAttached) {
      this.detachDragEvents();
    }
  };

  onWindowResize = () => {
    const width = window.innerWidth;

    if (width <= 1024) {
      if (!this.scrollerEventsAttached) {
        this.attachDragEvents();
      }
    } else {
      if (this.scrollerEventsAttached) this.detachDragEvents();
    }
  };

  attachDragEvents = () => {
    const scroller = document.getElementById(this.scrollerId);

    if (scroller) {
      this.scrollerEventsAttached = true;
      scroller.addEventListener("mousedown", this.onMouseDown);
      scroller.addEventListener("mouseup", this.onMouseUp);
      scroller.addEventListener("mousemove", this.onMouseMove);
    }
  };

  detachDragEvents = () => {
    const scroller = document.getElementById(this.scrollerId);

    if (scroller) {
      this.scrollerEventsAttached = false;
      scroller.removeEventListener("mousedown", this.onMouseDown);
      scroller.removeEventListener("mouseup", this.onMouseUp);
      scroller.removeEventListener("mousemove", this.onMouseMove);
    }
  };

  onMouseDown = (e) => {
    const scroller = document.getElementById(this.scrollerId);
    if (scroller) {
      scroller.classList.add("sp-scroller-no-snap");
      this.isDown = true;
      this.startX = e.pageX - scroller.offsetLeft;
      this.scrollLeft = scroller.scrollLeft;
    }
  };

  onMouseUp = () => {
    this.isDown = false;
    const scroller = document.getElementById(this.scrollerId);
    if (scroller) {
      scroller.classList.remove("sp-scroller-no-snap");
    }
  };

  onMouseMove = (e) => {
    if (!this.isDown) return;
    e.preventDefault();
    const scroller = document.getElementById(this.scrollerId);
    if (scroller) {
      const x = e.pageX - scroller.offsetLeft;
      const walk = (x - this.startX) * 1; //scroll-fast
      scroller.scrollLeft = this.scrollLeft - walk;
    }
  };
}

export default Scroller;
